import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import CustomSidePanel from "../../../../../components/blank-side-pannel/custom-side-pannel";
import { BlueGradientButton } from "../../../../../components/button";
import * as accountCampaignPricingWhatsappActions from "../../../store/actions/account_campaign_pricing_whatsapp_actions";

export default function AccountCampaignPricingWhatsappSidePanel({ show, pricingData, handleClose }) {
  const [formData, setFormData] = useState({});
  const dispatch = useDispatch();
  const params = useParams();

  useEffect(() => {
    const { price, additionalPrice } = pricingData || {};
    const tempFormData = {
      price,
      additionalPrice,
      finalPrice: ((price || 0) + (additionalPrice || 0)).toFixed(4),
    };
    setFormData(tempFormData);
  }, [pricingData]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      id: params.accountId,
      loadingData: { id: params.accountId },
      data: {
        accountId: params.accountId,
        _id: pricingData._id,
        additionalPrice: formData.additionalPrice,
      },
    };
    dispatch(accountCampaignPricingWhatsappActions.editPricingOfAccountWhatsapp2CampaignRequest(payload));
    handleClose();
  };

  const handleChange = (inputKey, inputValue) => {
    if (inputKey === "additionalPrice") {
      const _inputValue = typeof inputValue === "number" ? inputValue : Number(inputValue);

      setFormData((prev) => {
        return {
          ...prev,
          [inputKey]: _inputValue,
          finalPrice: ((_inputValue || 0) + (prev.price || 0)).toFixed(4).replace(/\.?0+$/, ''),
        };
      });
    }
    else if (inputKey === "finalPrice") {
      const _inputValue = typeof inputValue === "number" ? inputValue : Number(inputValue);
      setFormData((prev) => {
        return {
          ...prev,
          [inputKey]: _inputValue,
          additionalPrice: ((_inputValue || 0) - (prev.price || 0)).toFixed(4).replace(/\.?0+$/, ''),
        };
      });
    }
    else {
      setFormData((prev) => {
        return {
          ...prev,
          [inputKey]: inputValue,
        };
      });
    }
  };

  return (
    <CustomSidePanel
      title={`Country Name: ${pricingData.countryName}`}
      show={show}
      moduleName="Campaign Pricing - Whatsapp"
      handleClose={handleClose}
      customStyles={{
        width: "50vw",
        right: "51vw",
      }}
    >
      <div className="card-header d-flex flex-stack align-items-center">
        <h3 className="card-title fw-bolder text-dark">{`Country Name: ${pricingData.countryName}`}</h3>
      </div>
      <div style={{ height: "calc(100vh - 70px)", overflowY: "auto" }} className="p-8">
        <FormDisplay {...{ formData, handleChange, handleClose, handleSubmit }} />
      </div>
    </CustomSidePanel >
  );
}

const FormDisplay = ({ formData, handleChange, handleClose, handleSubmit }) => {
  return (
    <Form onSubmit={handleSubmit} noValidate>
      <Row>
        <Col className="form-group" xs={6}>
          <label className="form-label text-gray-700">Final Price</label>
          <Form.Control type="number" value={formData.finalPrice ?? 0} onChange={(e) => handleChange("finalPrice", e.target.value)} />
        </Col>
      </Row>

      <Form.Group className="d-flex gap-3 mt-10">
        <Button type="button" size="sm" variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <BlueGradientButton size="sm" type="submit">
          Save
        </BlueGradientButton>
      </Form.Group>
    </Form>
  );
};
